export const notificationStatuses = {
    DRAFT: 'Создано',
    CREATED: 'Создано',
    READY: 'Готово',
    SIGNED: 'Отправлено',
    APPROVED: 'Принято',
    DECLINED: 'Отклонено',
    RECEIVED: 'Получено',
    DELAYED: 'Просрочено'
}

export const noStates = {
    0: 'Создано',
    5: 'Просрочено',
    10: 'Отправлено',
    15: 'Получено',
    20: 'Принято',
    50: 'Отклонено'

}

export const notificationStates = {
    '0': 'CREATED',
    '5': 'OUTDATED',
    '10': 'ACTIVE',
    '15': 'RECEIVED',
    '20': 'APPROVED',
    '50': 'DECLINED'

}

export const notificationKinds = {
    START: 'О начале производства строительно-монтажных работ',
    RENEW: 'О возобновлении производства строительно-монтажных работ',
}

export const replyTypes = {
    REGISTRATION:'о получении уведомления и регистрации объекта строительства',
    ENROLLMENT:'о принятии объекта строительства на учет',
}

export const org_attr = {
    org_name: "Наименование юридического лица",
    website: "Вебсайт",
    email: "Email",
    country: "Страна",
    state: "Область",
    region: "Район",
    city: "Населенный пункт",
    street:"Адрес улицы",
    phone: "Номер телефона",
    tax_company_name: "Наименование Инспекции по налогам и сборам",
    okpo: "ОКПО",
    unp: "УНП",
    certificate_number: "Номер аттестата соответствия и его категория",
    certificate_date:"Дата выдачи аттестата соответствия"
}

export const user_attr = {
    full_name: "Имя Фамилия Отчество",
    email: "Email",
    password: "Пароль"
}

export const notification_attributes = {
    outgoing_number: "Исходящий номер уведомления",
    kind:'Тип уведомления',
    client_org_name:'Наименование юридического лица (фамилия, собственное имя, отчество (если таковое имеется) индивидуального предпринимателя)',
    client_org_country:'Страна',
    client_org_state:'Область',
    client_org_region:'Район',
    client_org_city:'Населенный пункт',
    client_org_street:'Адрес',
    client_org_block:'Дом',
    client_org_building:'Корпус',
    client_org_office:'Помещение',
    client_org_phone:'Номер телефона',
    client_tax_comp_name:'Наименование Инспекции по налогам и сборам',
    client_org_okpo:'ОКПО',
    client_org_unn:'УНН',
    client_org_conformity_certificate_index:'Номер аттестата соответствия и его категория',
    client_org_certificate_date:'Дата выдачи аттестата соответствия',
    object_name:'Наименование объекта',
    object_country:'Страна',
    object_state:'Область',
    object_region:'Район',
    object_city:'Населенный пункт',
    object_street:'Улица',
    object_block:'Дом',
    object_building:'Корпус',
    object_address_approximate:'Неточный адрес',
    inspection_id: 'Инспекция Департамента контроля и надзор за строительной деятельностью',
    inspection: 'Инспекция Департамента контроля и надзор за строительной деятельностью',
    registered_inspection_id: 'зарегистрированном в Инспекции Департамента контроля и надзор за строительной деятельностью',
    object_address_lon:'долгота',
    object_address_lat:'широта',
    // org_id:'',
    renew_start_date:'Дата возобновления работ',
    start_date:'Дата начала работ',
    decision_org_name:'Наименование местного исполнительного и распорядительного органа',
    decision_date:'Дата принятия решения',
    decision_index:'Номер решения',
    project_manager_name:'Фамилия, собственное имя, отчество (если таковое имеется)',
    project_manager_position:'Должность',
    project_manager_phone:'Номер телефона',
    order_index:'Номер приказа',
    order_date:'Дата приказа',
    design_company_name:'Наименование юридического лица (фамилия, собственное имя, отчество (если таковое имеется) индивидуального предпринимателя)',
    design_company_country:'Страна',
    design_company_state:'Область',
    design_company_region:'Район',
    design_company_city:'Населенный пункт',
    design_company_street:'Адрес',
    design_company_phone:'Номер телефона',
    design_approval_company_name:'Наименование юридического лица (фамилия, собственное имя, отчество (если таковое имеется) индивидуального предпринимателя)',
    design_approval_order_date:'Дата приказа',
    state_expertise_org_name:'Наименование органа государственной экспертизы',
    expertise_resolution_date:'Дата заключения экспертизы',
    expertise_resolution_index:'Номер заключения экспертизы',
    developer_name:'Наименование юридического лица (фамилия, собственное имя, отчество (если таковое имеется) индивидуального предпринимателя)',
    developer_country:'Страна',
    developer_state:'Область',
    developer_region:'Район',
    developer_city:'Населенный пункт',
    developer_street:'Адрес',
    developer_phone:'Номер телефона',
    developer_conformity_certificate_number:'Номер аттестата соответствия',
    certificate_category:'Категория',
    developer_agreement_number :'Номер договора',
    developer_start:'Дата начала строительства по договору строительного подряда',
    developer_term:'Нормативный срок строительства объекта',
    developer_agreement_date:'Дата договора',
    responsible_org_name:'Фамилия, собственное имя, отчество (если таковое имеется)',
    responsible_org_position:'Должность',
    responsible_org_phone:'Номер телефона',
    responsible_org_agreement_number:'Номер приказа',
    responsible_org_agreement_date:'Дата приказа',
    supervision_name:'Наименование юридического лица (фамилия, собственное имя, отчество (если таковое имеется) индивидуального предпринимателя)',
    supervision_country:'Страна',
    supervision_state:'Область',
    supervision_region:'Район',
    supervision_city:'Населенный пункт',
    supervision_street:'Адрес',
    supervision_phone:'Номер телефона',
    supervision_certificate_number:'Номер аттестата',
    supervision_certificate_category:'Категория',
    author_supervision_name:'Наименование юридического лица (фамилия, собственное имя, отчество (если таковое имеется) индивидуального предпринимателя)',
    author_supervision_country:'Страна',
    author_supervision_state:'Область',
    author_supervision_region:'Район',
    author_supervision_city:'Населенный пункт',
    author_supervision_street:'Адрес',
    author_supervision_phone:'Номер телефона',
    author_supervision_complexity_class:'Класс сложности объекта',
    estimated_budget:'Согласно сводному сметному расчету',
    state_budget:'За счет республиканского и (или) местного бюджета',
    other_sources_budget:'За счет иных источников',
    earmarked_contributions:'Сумма',
    payment_order_index:'Номер платежных поручений',
    payment_order_date:'Дата платежных поручений',
    description: 'При необходимости в установленную форму могут быть добавлены строки для изложения сведений'
}

export const bo_attributes = {
    is_published: 'опубликована',
    inspection_name:'Наименование инспекции',
    registration_number:'Номер регистрации',
    registration_date:'Дата регистрации',
    development_start_date:'Дата начала работ',
    development_finish_date:'Дата окончания работ',
    client_org_name:'Данные заказчика: Наименование юридического лица (фамилия, собственное имя,отчество(еслитаковоеимеется)индивидуальногопредпринимателя)',
    client_org_country:'страна',
    client_org_state:'Область',
    client_org_region:'Район',
    client_org_city:'Населенный пункт',
    client_org_street:'Адрес',
    client_org_phone:'тел',
    client_org_email:'почта',
    client_org_website:'сайт',
    client_org_responsible:'ФИО ответственного лица',
    object_name:'Наименование объекта',
    object_country:'страна',
    object_state:'Область',
    object_region:'Район',
    object_city:'Населенный пункт',
    object_street:'Улица',
    object_block:'Дом',
    object_building:'Корпус',
    object_address_approximate:'примерный аддрес',
    object_address_lon:'долгота',
    object_address_lat:'широта',
    org_id:'',
    design_company_name:'Данные проектрной документации. Наименование юридического лица (фамилия, собственное имя,отчество(еслитаковоеимеется)индивидуальногопредпринимателя)',
    design_company_country:'страна',
    design_company_state:'Область',
    design_company_region:'Район',
    design_company_city:'Населенный пункт',
    design_company_street:'Адрес',
    design_company_email:'почта',
    design_website:'сайт',
    design_responsible:'ФИО ответственного лица',
    developer_name:'Данные подрядчика. Наименование юридического лица (фамилия, собственное имя,отчество(еслитаковоеимеется)индивидуальногопредпринимателя)',
    developer_country:'страна',
    developer_state:'Область',
    developer_region:'Район',
    developer_city:'Населенный пункт',
    developer_street:'Адрес',
    developer_phone:'тел',
    developer_email:'почта',
    developer_website:'сайт',
    developer_responsible:'ФИО ответственного лица',
    supervision_name:'Данные тех надзора. Наименование юридического лица (фамилия, собственное имя,отчество(еслитаковоеимеется)индивидуальногопредпринимателя)',
    supervision_country:'страна',
    supervision_state:'Область',
    supervision_region:'Район',
    supervision_city:'Населенный пункт',
    supervision_street:'Улица',
    supervision_phone:'тел',
    supervision_email:'почта',
    supervision_website:'вебсайт',
    supervision_responsible:'ФИО ответственного лица',
    author_supervision_name:'Имя авторского надзора',
    author_supervision_country:'страна',
    author_supervision_state:'Область',
    author_supervision_region:'Район',
    author_supervision_city:'Населенный пункт',
    author_supervision_street:'Адрес',
    author_supervision_website:'вебсайт',
    author_supervision_responsible:'Ответственный за надзор',
    curator: 'Куратор',
    category:'Принадлежность',
    state:'Состояние'
}

export const role_names = {
    ROLE_INSPECTOR_MAIN: 'Администрирующий инспектор',
    ROLE_INSPECTOR_REPLIES: 'Инспектор по работе с извещениями',
    ROLE_INSPECTOR_APPEALS: 'Инспектор по работе с обращениями',
    ROLE_INSPECTOR_RECEIVE: 'Инспектор по регистрации входящего номера',
    ROLE_INSPECTOR_MANAGER: 'Начальник инспекции',
    ROLE_INSPECTOR_SUPER: 'Администрирование всех инспекций',
    ROLE_BUILD_ORG: 'Администратор строительной организации',
    ROLE_BUILD_USER: 'Участник строительной организации',
}

export const roles = {
    ROLE_SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
    ROLE_INSPECTOR_MAIN: 'ROLE_INSPECTOR_MAIN',
    ROLE_INSPECTOR_REPLIES: 'ROLE_INSPECTOR_REPLIES',
    ROLE_INSPECTOR_APPEALS: 'ROLE_INSPECTOR_APPEALS',
    ROLE_INSPECTOR_RECEIVE: 'ROLE_INSPECTOR_RECEIVE',
    ROLE_INSPECTOR_MANAGER: 'ROLE_INSPECTOR_MANAGER',
    ROLE_SUPERVISOR: 'ROLE_SUPERVISOR',
    ROLE_BUILD_ORG: 'ROLE_BUILD_ORG',
    ROLE_BUILD_USER: 'ROLE_BUILD_USER',
    
}

export const insp_roles = [ 'ROLE_INSPECTOR_MANAGER', 'ROLE_INSPECTOR_MAIN','ROLE_INSPECTOR_REPLIES', 'ROLE_INSPECTOR_APPEALS',  'ROLE_INSPECTOR_RECEIVE'];

export const org_roles = ['ROLE_BUILD_ORG', 'ROLE_BUILD_USER'];

export const org_types = {
    ORG_TYPE_INSPECTION:'инспекция',
    ORG_TYPE_ORG: 'стройорг.'
};



// WEBPACK FOOTER //
// ./assets/src/js/helpers/trans.jsx